import { render, staticRenderFns } from "./DilekceEditor.vue?vue&type=template&id=40ddb241"
import script from "./DilekceEditor.vue?vue&type=script&lang=ts"
export * from "./DilekceEditor.vue?vue&type=script&lang=ts"
import style0 from "./DilekceEditor.vue?vue&type=style&index=0&id=40ddb241&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports